var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"font-14 has-text-greyText mb-2"},[_c('p',{staticClass:"break-name"},[_vm._v(_vm._s(_vm.user.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }